import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/buyer-credit-list',
      name: 'admin-buyer-credit-list',
      component: () => import(/* webpackChunkName: "page-admin-buyer-management-buyer-credit-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "分销商授信管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "分销商管理"
                                        },
                                        {
                                                  name: "分销商授信管理"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
